export function brandImage(branding, theme, field) {
  const night = branding?.[`${field}_url`];
  const day = branding?.[`${field}_light_url`];
  const url = theme === "light" ? day || night : night;
  if (!url) return null;
  return url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
